"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomTableSupport = void 0;
class CustomTableSupport {
    static columnOf(headers, id) {
        for (let i = 0; i < headers.length; i++) {
            if (headers[i].id === id) {
                return i;
            }
        }
        return -1;
    }
    static githubIdCell(personIds, peopleById) {
        if (personIds.length === 0) {
            return { value: "N/A", html: "N/A" };
        }
        const ids = [];
        const html = [];
        for (const id of personIds) {
            const person = peopleById.get(id);
            if (typeof (person === null || person === void 0 ? void 0 : person.githubId) !== "string") {
                ids.push(id);
                html.push(CustomTableSupport.escapeAttribute(id));
                continue;
            }
            ids.push(person.githubId);
            const name = CustomTableSupport.escapeAttribute(person.githubId);
            if (typeof person.userUrl === "string" && person.userUrl.length > 0) {
                html.push('<a class="selectable" href="' + CustomTableSupport.escapeAttribute(person.userUrl) + '">' + name + "</a>");
            }
            else {
                html.push(name);
            }
        }
        return { value: ids.join(", "), html: html.join(", ") };
    }
    static escapeAttribute(value) {
        return String(value)
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#39;");
    }
    static withBucketTooltip(cell, bucket) {
        if (typeof bucket !== "string" || bucket.length === 0) {
            return cell;
        }
        const title = CustomTableSupport.escapeAttribute(bucket);
        return { value: cell.value, html: '<span title="' + title + '">' + cell.html + "</span>" };
    }
    static toInstructorPrairieLearnUrl(url) {
        if (typeof url !== "string") {
            return url;
        }
        return url.replace(/(\/pl\/course_instance\/\d+\/)assessment_instance\//, "$1instructor/assessment_instance/");
    }
}
exports.CustomTableSupport = CustomTableSupport;
